import React from 'react';
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';

import i18n from '../i18n';
import PropTypes from 'prop-types'
import store from "../store/index";

class NewLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            lang: localStorage.getItem('lang'),
            isActive: false,
            errors: {}
        };
        this.sendDetailsToServer = this.sendDetailsToServer.bind(this);

        localStorage.removeItem(ACCESS_TOKEN_NAME);


    }
    notify = (e) => {
        e.preventDefault();

        this.props.history.push('/register');

    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    fpHandler = (event) => {


        event.preventDefault();
        //this.props.history.push('/validate');
        if (!this.state.username) {
            ///formIsValid = false;
            Swal.fire({
                title: 'Error!',
                text: 'Please enter valid mobile!',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            //errors["username"] = "Please enter valid username";
        } else {
            this.forgotPassword(this.state);
        }
    }
    mySubmitHandler = (event) => {
        let errors = {};

        event.preventDefault();
        //this.props.history.push('/validate');
        if (!this.state.username) {
            ///formIsValid = false;
            Swal.fire({
                title: 'Error!',
                text: 'Please enter valid mobile!',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            //errors["username"] = "Please enter valid username";
        }
        else if (!this.state.password) {
            Swal.fire({
                title: 'Error!',
                text: 'Please enter valid password!',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            // errors["password"] = "Please enter valid password";
        }
        else {
            console.log("You are submitting " + JSON.stringify(this.state));
            this.sendDetailsToServer(this.state);
        }


        this.setState({ errors: errors });

    }
    sendDetailsToServer = (data) => {

        this.setState({ isActive: true });



        const devicedetails = {
            "imei": "862188038288320",
            "deviceOSVersion": "6.0.1",
            "uuid": "862188038288320",
            "deviceModel": "NOKIA 100",
            "deviceManufacturer": "Xiaomi",
            "serviceProvider": "airtel",
            "deviceOS": "ANDROID",
            "ipAddress": "192.168.43.210"
        }
        const headers = {
            "RequestMode": "0",
            "UserID": "3",
            "BearerKey": "Mobile",
            "ServiceId": "SERV!",
            "SessionId": "1236545",
            "Locale": "E/A",
            "DeviceDet": devicedetails

        }
        const payload = {
            "username": this.state.username,
            "password": this.state.password,
            ReqHead: headers
        }
        //localStorage.setItem(ACCESS_TOKEN_NAME,'response.data.token');
        let self = this; //  declared var 

        // redirectToHome();+
        console.log('calling api ...' + JSON.stringify(payload));
        axios.post(API_MOSA_URL + '/Login/SignIn', payload)
            .then(function (response) {
                self.setState({ isActive: false });

                console.log(JSON.stringify(response));

                if (response.status === 200) {
                    //this.props.history.push('/validate');
                    if (response.data[0].StatusCode == "0") {

                        localStorage.setItem(ACCESS_TOKEN_NAME, response.data[1].SessionID);
                        localStorage.setItem("userPhone", response.data[1].userPhone);
                        localStorage.setItem("userEmail", response.data[1].userEmail);
                        localStorage.setItem("enableeditprofile", "true");
                        localStorage.setItem("userid", response.data[1].userid);
                        localStorage.setItem("username", response.data[1].username);
                        localStorage.setItem("usertype", response.data[1].usertype);
                        if (response.data[1].usertype != "User") {
                            self.props.history.push('/myaccount');
                        } else {
                            self.props.history.push('/welcome');
                        }


                    }
                    else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });

                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            });

    }
    forgotPassword = (data) => {

        this.setState({ isActive: true });



        const devicedetails = {
            "imei": "862188038288320",
            "deviceOSVersion": "6.0.1",
            "uuid": "862188038288320",
            "deviceModel": "NOKIA 100",
            "deviceManufacturer": "Xiaomi",
            "serviceProvider": "airtel",
            "deviceOS": "ANDROID",
            "ipAddress": "192.168.43.210"
        }
        const headers = {
            "RequestMode": "0",
            "UserID": "3",
            "BearerKey": "Mobile",
            "ServiceId": "SERV!",
            "SessionId": "1236545",
            "Locale": "E/A",
            "DeviceDet": devicedetails

        }
        const payload = {
            "Username": this.state.username,
            ReqHead: headers
        }
        //localStorage.setItem(ACCESS_TOKEN_NAME,'response.data.token');
        let self = this; //  declared var 

        // redirectToHome();+
        console.log('calling api ...' + API_MOSA_URL + '/User/ForgotPassword' + '..' + JSON.stringify(payload));
        axios.post(API_MOSA_URL + '/User/ForgotPassword', payload)
            .then(function (response) {
                self.setState({ isActive: false });

                console.log(JSON.stringify(response));

                if (response.status === 200) {
                    //this.props.history.push('/validate');
                    if (response.data[0].StatusCode == "0") {

                        Swal.fire({
                            title: 'Success!',
                            text: response.data[0].Message,
                            icon: 'success',
                            confirmButtonText: 'Ok'
                        })


                    }
                    else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });

                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            });





    }
    componentDidMount() {
        window.scrollTo(0, 0)

        // localStorage.clear();
    }
    render() {

        let self = this;
        store.subscribe(() => {
            console.log('change lang' + store.getState().lang);
            localStorage.setItem('lang', store.getState().lang)

            self.setState({ lang: localStorage.getItem('lang') });
        });
        localStorage.removeItem(ACCESS_TOKEN_NAME);
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >
                <div style={{ backgroundColor: '#dfe6e9' }}>
                    <Navbar />
                    <div className="all-title-box">
                        <div className="container text-center ">
                            <h1 className="spectitle"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK7', this.state.lang)}<span className="m_1">{i18n.t('LN2', this.state.lang)}</span></h1>
                        </div>
                    </div>
                    <section className="testimonial py-3" id="testimonial">
                        <div className="container">
                            <form role="form" className="form-horizontal" onSubmit={this.mySubmitHandler}>

                                <div className="row " style={{backgroundColor:'white'}}>
                                    <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#4c5a7d ' }}>
                                        <div className=" ">
                                            <div className="card-body">
                                                <img src="http://www.ansonika.com/mavia/img/registration_bg.svg" style={{ width: '30%' }} />

                                                <h2 className="py-3"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('IR1', this.state.lang)}</h2>
                                                <p  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK2', this.state.lang)}
                                                </p>
                                                <a className="btn btn-primary" href="/register"  style={{ fontFamily: 'Tajawal' }}><span style={{ color: 'lightgrey' }}>{i18n.t('JK3', this.state.lang)}</span></a>

                                                <h2 className="py-3"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('CR1', this.state.lang)}</h2>
                                                <p>{i18n.t('JK1', this.state.lang)}
                                                </p>
                                                <a className="btn btn-primary" href="/companyregister"  style={{ fontFamily: 'Tajawal' }}><span style={{ color: 'lightgrey' }}>{i18n.t('JK6', this.state.lang)}</span></a>


                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8 py-5 border">
                                        <div className="card-body" style={{ minHeight: '300px' }}>


                                            <div className="container">
                                                <div class="text-left">
                                                    <h3>{i18n.t('JK7', this.state.lang)}</h3>
                                                </div>
                                                <hr />

                                                <div className="form-group row">
                                                    <div className="col  text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK9', this.state.lang)}</label>
                                                        <input className="form-control" type="text" name="username" onChange={this.myChangeHandler} placeholder={i18n.t('LN3', this.state.lang)} autoComplete="off" />

                                                        <span className="form-text text-muted">{i18n.t('JK10', this.state.lang)}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}> {i18n.t('JK11', this.state.lang)}</label>
                                                        <input type="password"
                                                            name="password"
                                                            value={this.state.password}
                                                            className={this.state.errors["password"] ? "form-control is-invalid" : "form-control"}
                                                            placeholder={i18n.t('JK11', this.state.lang)}
                                                            onChange={this.myChangeHandler} />
                                                        <span className="form-text text-muted"> {i18n.t('JK12', this.state.lang)}</span>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                        <div className="card-footer">

                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <button type="submit" className="btn btn-light btn-radius btn-brd grd1" >
                                                        {i18n.t('JK7', this.state.lang)}
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <button type="buttton" onClick={e => this.fpHandler(e)} className="btn btn-light btn-radius btn-brd grd1">
                                                        {i18n.t('JK13', this.state.lang)}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </section>

                    <Footer />
                    {/* <div className="row">


                    <div className="col-md-12 text-center" style={{ padding: '10px', background: 'lightgrey' }}>
                        <div className="text-center">
                            <div className="card loginCard  customer-box" style={{}}>
                                <div className="tab-content">
                                    <ul className="nav nav-tabs text-center">
                                        <li><a className="active" href="#Login" data-toggle="tab">Login using Mobile Number/Username</a></li>
                                    </ul>
                                    <br/>
                                    <div className="tab-pane active" id="Login">
                                        <form role="form" className="form-horizontal" onSubmit={this.mySubmitHandler}>
                                            <div className="form-group">
                                                <div className="col-sm-12">
                                                    <input className="form-control" type="text" name="username" onChange={this.myChangeHandler} placeholder="Mobile Number" autoComplete="off" />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-sm-12">
                                                    <input className="form-control" type="password" name="password" onChange={this.myChangeHandler} placeholder="Password" />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <button type="submit" className="btn btn-light btn-radius btn-brd grd1">
                                                        Submit
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <button onClick={e => this.notify(e)} className="btn btn-light btn-radius btn-brd grd1">
                                                        Register
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div > */}
                </div>
            </LoadingOverlay>
        )
    }
}

export default NewLogin; 